module.exports = __webpack_public_path__ + "static/media/Complete-Care-Logo-sm.6fee0103.png";